import { Gender } from '@/graphql/types'
import { LinkButton } from '@/react/client/components/Basics'
import {
  ConsultationCard,
  Props as ConsultationCardProps,
} from '@/react/client/components/ConsultationCard'
import { AboutConsultation } from '@/react/shared/components/AboutCosultation'
import { AuthButtons } from '@/react/shared/components/AuthButtons'
import React from 'react'
import HeroPC from '../../../images/lp/hero_pc.png'
import HeroSP from '../../../images/lp/hero_sp.png'
import Img1 from '../../../images/lp/img1.png'
import Img2 from '../../../images/lp/img2.png'
import Img3 from '../../../images/lp/img3.png'
import Img4 from '../../../images/lp/img4.png'

export const Content: React.FC = () => {
  const consultations: Array<ConsultationCardProps['consultation']> = [
    {
      id: 'sample-1',
      gender: Gender.Female,
      age: 30,
      title: '母が同じ話を繰り返すのが気になります。',
      body:
        '70代の母が、同じ話を何度も繰り返すことが増えてきました。たとえば、同じ思い出話を1日の中で何度も話すことがあります。母自身は「年のせいよ」と笑っていますが、家族としては不安です。専門の医療機関を受診すべきでしょうか？',
      createdAt: '',
    },
    {
      id: 'sample-2',
      gender: Gender.Male,
      age: 20,
      title: '父が怒りっぽくなりました。これは認知症の症状ですか？',
      body:
        '60代の父が、些細なことで怒ることが増えました。テレビを見ているときに急に怒鳴るなど、これまでは穏やかな性格だったので戸惑っています。認知症と関係はありますか？',
      createdAt: '',
    },
    {
      id: 'sample-3',
      gender: Gender.Male,
      age: 70,
      title: '何をするのもおっくうだと感じます。',
      body:
        '70代の男性です。最近、何をするにも面倒に感じ、ほとんど家から出なくなりました。好きだったテレビ番組や趣味が楽しいと思えず、ぼんやりと過ごしている日々です。このままでよいのかと不安です。',
      createdAt: '',
    },
    {
      id: 'sample-4',
      gender: Gender.Female,
      age: 60,
      title: '大事な物をどこに置いたか忘れて、いつも探し物をしています。',
      body:
        '60代の女性です。財布や鍵などをどこに置いたか忘れてしまい、探し物をすることが多くなりました。物忘れは年のせいだから仕方がないと思っていましたが、家族が指摘するので自分でも気になり始めました。',
      createdAt: '',
    },
  ]

  const centeredAuthButtons = (dataMnCspLocation: string) => (
    <div className="pc:w-pc-inner-xs pc:mx-auto mx-4">
      <div className="mx-auto">
        <AuthButtons dataMnCspLocation={dataMnCspLocation} />
      </div>
    </div>
  )

  return (
    <div className="p-qa_mild_cognitive_impairment">
      <div className="p-qa_mild_cognitive_impairment__contents">
        <div className="p-qa_mild_cognitive_impairment__hero">
          <picture className="p-qa_mild_cognitive_impairment__hero-img-wrapper">
            <source srcSet={HeroPC} media="(min-width: 960px)" />
            <source srcSet={HeroSP} media="(min-width: 320px)" />
            <img
              className="p-qa_mild_cognitive_impairment__hero-img"
              src={HeroPC}
              alt="カバー画像"
            />
          </picture>
          <div className="p-qa_mild_cognitive_impairment__hero-text-box">
            <div className="p-qa_mild_cognitive_impairment__hero-text-box-inner">
              <p className="p-qa_mild_cognitive_impairment__hero-text--md">
                認知症専門<span>の</span>医療相談<span>が</span>
              </p>
              <div className="p-qa_mild_cognitive_impairment__hero-text-box-bottom">
                <div>
                  <p className="p-qa_mild_cognitive_impairment__hero-text--sm">
                    このサイトからの会員登録で
                  </p>
                  <p className="p-qa_mild_cognitive_impairment__hero-text--lg">
                    <s>月額432円</s>
                    <span className="p-qa_mild_cognitive_impairment__hero-text-arrow">
                      ➡
                    </span>
                  </p>
                </div>
                <p className="p-qa_mild_cognitive_impairment__hero-text--xl">
                  無料
                </p>
              </div>
            </div>
          </div>
          <div className="mt-4">{centeredAuthButtons('本文中_01')}</div>
        </div>
        <div className="p-qa_mild_cognitive_impairment__inner">
          <div className="text-center">
            <h2>「認知症」</h2>
            <p className="font-bold text-xl text-link-color">
              こんなお悩みに医師がお答えします
            </p>
          </div>
          <div className="p-qa_mild_cognitive_impairment__cards">
            {consultations.map((consultation) => (
              <ConsultationCard
                key={consultation.id}
                consultation={consultation}
              />
            ))}
          </div>
          <div className="pc:w-pc-inner-xs mt-6 pc:mx-auto">
            <LinkButton
              href="/features/qa/mild_cognitive_impairment/consultations/list"
              className="text-link-color border-link-color border-solid border bg-white"
              variant="white"
            >
              すべての相談を見る
            </LinkButton>
          </div>
        </div>
        <div className="p-qa_mild_cognitive_impairment__inner">
          <div>
            <h3>認知症とは</h3>
            <div className="mt-8 text-xl">
              <p>
                認知症は、高齢化社会において注目される疾患の一つであり、脳の機能が徐々に低下し、日常生活に影響を及ぼすようになる病気です。
              </p>
              <p className="mt-6">
                多くの方が、物忘れや判断力の低下、行動の変化を通じて認知症の兆候を感じることがありますが、症状や進行度は個人差が大きく、原因もさまざまです。認知症に関する基本的な理解を深め、適切な対応策を知ることは、早期発見や生活の質の向上につながります。
              </p>
            </div>
          </div>
        </div>
        <div className="mt-8">{centeredAuthButtons('本文中_02')}</div>

        <div className="p-qa_mild_cognitive_impairment__inner">
          <h3>認知症の主な症状と特徴</h3>
          <div className="p-qa_mild_cognitive_impairment__list">
            <ul>
              <li>
                <span className="p-qa_mild_cognitive_impairment__list-item-text">
                  <span className="font-bold text-link-color">記憶障害</span>
                  ：日常的な出来事を忘れやすくなる。最近の記憶が特に影響を受けやすい。
                </span>
                <div className="flex justify-center">
                  <img src={Img1} alt="" />
                </div>
              </li>
              <li>
                <span className="p-qa_mild_cognitive_impairment__list-item-text">
                  <span className="font-bold text-link-color">見当識障害</span>
                  ：時間や場所、状況を正しく認識するのが難しくなる。
                </span>
                <div className="flex justify-center">
                  <img src={Img2} alt="" />
                </div>
              </li>
              <li>
                <span className="p-qa_mild_cognitive_impairment__list-item-text">
                  <span className="font-bold text-link-color">
                    判断力・思考力の低下
                  </span>
                  ：適切な判断や計画を立てることが難しくなり、日常生活での問題解決が困難になる。
                </span>
                <div className="flex justify-center">
                  <img src={Img3} alt="" />
                </div>
              </li>
              <li>
                <span className="p-qa_mild_cognitive_impairment__list-item-text">
                  <span className="font-bold text-link-color">
                    性格・行動の変化
                  </span>
                  ：穏やかだった性格が攻撃的になるなど、性格や行動が変わることもある。
                </span>
                <div className="flex justify-center">
                  <img src={Img4} alt="" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8">{centeredAuthButtons('本文中_03')}</div>
        <div className="mt-4">
          <AboutConsultation />
        </div>
        <div className="mt-8">{centeredAuthButtons('本文中_04')}</div>
        <div className="p-qa_mild_cognitive_impairment__inner">
          <h3>このサービスについて</h3>
          <p>
            このサービスは株式会社メディカルノートが運営する、オンライン医療相談サービスです。認知症に関するご相談について、医療チームがWebサイト上でご回答をいたします。
            <br />
            <br />
            このサービスの利用については「
            <a
              href="https://medicalnote-qa.jp/term_of_service"
              className="text-link-color"
              target="_blank"
              rel="noreferrer"
            >
              Medical Note 医療相談サービス　利用規約（個人会員規約）
            </a>
            」が適用されますが、サービス利用範囲は以下のとおりとなり、同利用規約の第3条（会員の定義と利用範囲）に優先します。
          </p>
          <h4>本サービスにおける利用範囲</h4>
          <ul>
            <li>
              本サービスにおいて、Medical
              Note医療チームに対し、認知症に関する医療相談を投稿することができ、またその相談に対する回答を見ることができます。また、回答に対する聞き返しの投稿をすることができます。
            </li>
          </ul>
          <h3>注意事項</h3>
          <ul>
            <li>
              この相談窓口は認知症に関する相談を受け付ける窓口です。この窓口にそぐわない内容の相談であると運営が判断した場合、回答を控えさせていただく場合がございます。
            </li>
            <li>
              相談において、お名前や住所などの個人情報の入力はしないようお願いいたします。
            </li>
            <li>
              相談に対する回答においては医療に関する情報を提供しますが、診療を行うものではありません。
            </li>
            <li>
              サプリメントや市販薬を含め、薬の服用に関するアドバイスはいたしかねます。
            </li>
            <li>
              必ず自己の責任においてサービスを利用し、ご自身の判断に基づき必要な医療機関の受診をお願いいたします。
            </li>
          </ul>
        </div>
        <div className="mt-8">{centeredAuthButtons('本文中_05')}</div>
      </div>
    </div>
  )
}
